<template>
	<form class="review-form clear_fix" @submit.prevent="createReview">
		<i class="review-form__close-icon icon ion-android-close" @click="closeEditor"></i>
		<div class="columns small-12 medium-8 large-8">

			<div class="review-form__inner">
				<h4 class="review-form__main-title">
					<span v-if="whom === 'doctor'">
						Отзыв о враче '{{subject.last_name}} {{subject.first_name}} {{subject.middle_name}}'
					</span>
					<span v-else>Отзыв о клинике '{{subject.name}}'</span>
				</h4>
			</div>

			<div class="review-form__inner">
				<label class="review-form__label">Заголовок отзыва:</label>
				<input v-model="reviewModel.title" class="review-form__field" placeholder="Введите текст" required>
			</div>

			<div class="review-form__inner">
				<label class="review-form__label">Отзыв:</label>
				<textarea v-model="reviewModel.text" class="review-form__field review-form__field_textarea"
									placeholder="Введите текст" required></textarea>
			</div>

			<div class="review-form__inner">
				<div class="review-form__message">
					<span class="review-form__star">*</span> - звездочкой отмечены поля, обязательные для заполнения
				</div>
			</div>

		</div>
		<!--Column End-->

		<div class="columns small-12 medium-4 large-4">
			<div class="review-form__message">
				Оцените данного врача<span class="review-form__star">*</span>:
			</div>
			<div class="rating-stars review__rating-stars">
				<stars v-model="reviewModel.stars"></stars>
			</div>
		</div>
		<!--Column End-->

		<div class="columns small-12 medium-12 large-12">
			<div class="basic-btn review-section__btn">
				<input type="submit" class="basic-btn__item basic-btn__item_review" value="Оставить отзыв"/>
			</div>
		</div>
		<!--Column End-->

	</form>
</template>

<script>
	import _ from 'underscore';
	import Stars from '@/components/Stars/Stars.vue';

	export default {
		name: "Editor",
		props: ['whom', 'subject'],
		components: {Stars},
		mounted() {
			this.reviewModel.obj_id = this.subject._id;
			this.reviewModel.obj_type = (this.whom === 'doctor') ? 'user' : 'clinic';
		},
		beforeDestroy() {
			this.reviewModel = {};
		},
		data() {
			return {
				reviewModel: {}
			}
		},
		methods: {
			closeEditor() {
				this.$emit('close');
			},
			createReview() {
				this.reviewModel.stars = this.reviewModel.stars || 1;

				this.$store.dispatch('review/create', this.reviewModel)
					.then(() => this.closeEditor());
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Editor.vue?1b440970